import React from 'react';
import createImageAlt from 'presentation/utils/createImageAlt';

import Parallax from './Parallax';
import Static from './Static';
import { classNames } from './Layer.stylesheet';

export interface Layer {
  imageUrl?: string;
  focus: string;
  webpUrl?: string;
  fx: {
    type: string;
  };
}

interface OuterProps {
  layer: Layer;
}

export const PureLayer = ({ layer }: OuterProps) => {
  const isParallax = layer.fx.type === 'parallax';
  const Layer = isParallax ? Parallax : Static;

  return (
    <div className={classNames.root} role="img" aria-label={createImageAlt(layer)}>
      <Layer layer={layer} />
    </div>
  );
};

PureLayer.displayName = 'Layer';

export default PureLayer;
